import { g as gsapWithCSS, S as ScrollTrigger } from "./vendor.js";
(function polyfill() {
  const relList = document.createElement("link").relList;
  if (relList && relList.supports && relList.supports("modulepreload")) {
    return;
  }
  for (const link of document.querySelectorAll('link[rel="modulepreload"]')) {
    processPreload(link);
  }
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== "childList") {
        continue;
      }
      for (const node of mutation.addedNodes) {
        if (node.tagName === "LINK" && node.rel === "modulepreload")
          processPreload(node);
      }
    }
  }).observe(document, { childList: true, subtree: true });
  function getFetchOpts(link) {
    const fetchOpts = {};
    if (link.integrity)
      fetchOpts.integrity = link.integrity;
    if (link.referrerPolicy)
      fetchOpts.referrerPolicy = link.referrerPolicy;
    if (link.crossOrigin === "use-credentials")
      fetchOpts.credentials = "include";
    else if (link.crossOrigin === "anonymous")
      fetchOpts.credentials = "omit";
    else
      fetchOpts.credentials = "same-origin";
    return fetchOpts;
  }
  function processPreload(link) {
    if (link.ep)
      return;
    link.ep = true;
    const fetchOpts = getFetchOpts(link);
    fetch(link.href, fetchOpts);
  }
})();
const style = "";
document.addEventListener("DOMContentLoaded", () => {
  const videos = document.querySelectorAll(".video[data-src]");
  if (!videos.length) {
    return;
  }
  const pickSuffix = (width) => width <= 768 ? "_sm" : "_lg";
  const updateVideoSource = (video, suffix, forcePlay = false) => {
    const baseSrc = video.dataset.src;
    if (!baseSrc) {
      return;
    }
    video.muted = true;
    video.playsInline = true;
    const targetSrc = `${baseSrc}${suffix}.mp4`;
    let source = video.querySelector('source[data-responsive-src="true"]');
    if (!source) {
      source = document.createElement("source");
      source.setAttribute("type", "video/mp4");
      source.setAttribute("data-responsive-src", "true");
      video.appendChild(source);
    }
    if (source.getAttribute("src") === targetSrc) {
      return;
    }
    const wasPlaying = !video.paused && !video.ended;
    source.setAttribute("src", targetSrc);
    video.load();
    if (wasPlaying || forcePlay) {
      video.play().catch(() => {
      });
    }
  };
  let currentSuffix = pickSuffix(window.innerWidth);
  videos.forEach((video) => updateVideoSource(video, currentSuffix, true));
  window.addEventListener("resize", () => {
    const nextSuffix = pickSuffix(window.innerWidth);
    if (nextSuffix === currentSuffix) {
      return;
    }
    currentSuffix = nextSuffix;
    videos.forEach((video) => updateVideoSource(video, currentSuffix));
  });
});
window.addEventListener("DOMContentLoaded", async () => {
  gsapWithCSS.config({ nullTargetWarn: false });
  gsapWithCSS.registerPlugin(ScrollTrigger);
  gsapWithCSS.set(".t-scroll", { autoAlpha: 0, y: 40 });
  ScrollTrigger.create({
    trigger: ".t-intro",
    start: "top 20%",
    onEnter: () => {
      gsapWithCSS.to(".t-scroll", {
        y: 0,
        autoAlpha: 1,
        duration: 0.6,
        ease: "power4.out"
        // }, '+=1.2');
      });
    },
    onEnterBack: () => {
      gsapWithCSS.to(".t-scroll", {
        y: 0,
        autoAlpha: 1,
        duration: 0.6,
        ease: "power4.out"
      });
    },
    onLeaveBack: () => {
      gsapWithCSS.to(".t-scroll", {
        y: 40,
        autoAlpha: 0,
        duration: 0.3,
        ease: "power2.out"
      });
    }
    // markers: true,
  });
  ScrollTrigger.create({
    trigger: ".t-product.-end",
    start: "bottom bottom",
    toggleClass: {
      targets: ".t-scroll",
      className: "-end"
    }
    // markers: true,
  });
  const header = document.querySelector(".t-header");
  const introTl = gsapWithCSS.timeline({
    scrollTrigger: {
      trigger: ".t-intro",
      start: "top 80%",
      onEnter: () => header == null ? void 0 : header.classList.add("is-view"),
      onLeaveBack: () => header == null ? void 0 : header.classList.remove("is-view")
      // markers: true,
    }
  });
  introTl.from(".t-intro__catch", {
    autoAlpha: 0,
    clipPath: "inset(100% 0 0 0)",
    duration: 0.6,
    ease: "power4.out"
  }).from(".t-intro__text", {
    autoAlpha: 0,
    duration: 6,
    ease: "power4.out"
  }, "-=0.2");
  document.querySelectorAll(".t-product").forEach((el) => {
    const title = el.querySelector(".t-product__title");
    const productTl = gsapWithCSS.timeline({
      scrollTrigger: {
        trigger: el,
        start: "top 80%"
        // markers: true,
      }
    });
    productTl.from(el, {
      autoAlpha: 0,
      clipPath: "inset(100% 0 0 0)",
      duration: 1.2,
      ease: "power4.out"
    }).from(title, {
      autoAlpha: 0,
      clipPath: "inset(100% 0 0 0)",
      duration: 2.4,
      ease: "power4.out"
    }, "-=0.6");
  });
});
document.addEventListener("DOMContentLoaded", function() {
  const video = document.querySelector("video");
  const vol = document.querySelector(".js-vol");
  if (video && vol) {
    vol.addEventListener("click", function() {
      video.muted = !video.muted;
      vol.classList.toggle("is-play");
    });
  }
});
